
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/open-account-offer",
      function () {
        return require("private-next-pages/open-account-offer.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/open-account-offer"])
      });
    }
  